var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{staticClass:"main-appbar",attrs:{"flat":"","color":"transparent"}},[_c('app-bar-nav-icon'),_c('v-toolbar-title',{staticClass:"headline font-weight-bold"},[_vm._v("Content")]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""}},[_c('img',{attrs:{"src":require("@/assets/icons/search.svg"),"alt":"","height":"17.7px"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }